document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-mobile-menu]').forEach((button) => {
    button.addEventListener('click', () => {
      const nav = document.querySelector('[data-mobile-nav]');
      if (!nav) return;
      nav.classList.toggle('is-open');
      button.setAttribute('aria-expanded', nav.classList.contains('is-open') ? 'true' : 'false');
    });
  });

  const variantSelect = document.querySelector('[data-variant-select]');
  const variantId = document.querySelector('[data-variant-id]');
  const price = document.querySelector('[data-product-price]');
  if (variantSelect && variantId) {
    variantSelect.addEventListener('change', () => {
      const option = variantSelect.options[variantSelect.selectedIndex];
      variantId.value = option.value;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
    });
  }
});